import { useRef } from 'react';

const useAutoRef = <T>(value: T) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};

export default useAutoRef;
